import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    title = ' | HandBook';

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
    ) {
        this.setPageTitle();
    }

    /** Sets the page title based on the current Route */
    setPageTitle() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }

                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data),
        ).subscribe((event) => {
            this.titleService.setTitle(event.title + this.title);
        });
    }
}
